<template>
  <div class="d-flex flex-column" style="height: 100%">
    <report-panel
      :isVisible.sync="isVisibleStatistics"
    >
      <template v-slot:content>
        <layout-statistics
          ref="layout-statistics"
          :partID="partID"
          :editorID="editorID"
        />
      </template>
    </report-panel>
    <layout-grid
      :partID="partID"
      :editorID="editorID"
      @on-quick-rfq="$emit('on-quick-rfq', $event)"
    />
  </div>
</template>
<script>
export default {
  name: 'SupplierQuotes',
  components: {
    'layout-statistics': () => import(/* webpackChunkName: 'Parts' */ './PanelStatistics/Index.vue'),
    'layout-grid': () => import(/* webpackChunkName: 'Parts' */ './LayoutGrid/Index.vue'),
    'report-panel': () => import(/* webpackChunkName: 'ReportPanel' */ '@/components/UI/ReportPanel.vue')
  },
  props: {
    partID: { required: true },
    editorID: { required: true }
  },
  mounted () {
    this.$bus.$on(`on-close-modal-${this.editorID}`, this.onCloseModal)
  },
  beforeDestroy () {
    this.$bus.$off(`on-close-modal-${this.editorID}`, this.onCloseModal)
  },
  data () {
    return {
      isVisibleStatistics: false,
      tools: [
        {
          name: 'statistics',
          label: this.L10n('statistics')
        }
      ]
    }
  },
  methods: {
    onCloseModal () {
      this.isVisibleStatistics = false
    }
  }
}
</script>
